'use client'

import React from 'react'

type Tone = 'red' | 'amber' | 'sky' | 'green'

// The design system's metric cell (ui/PageFrame.tsx Metric): mono label,
// a 25 px light number in its tone.
const TONE_CLS: Record<Tone, string> = {
  red:   'text-destructive',
  amber: 'text-warning',
  sky:   'text-signal',
  green: 'text-success',
}

export function StatTile({
  label,
  value,
  tone,
  isDark: _isDark,
}: {
  label: string
  value: string
  tone: Tone
  isDark: boolean
}) {
  return (
    <div className="bg-card px-5 py-4">
      <div className="font-mono text-micro uppercase tracking-[0.08em] text-muted-foreground">
        {label}
      </div>
      <div className={`mt-2 text-metric font-normal tabular-nums tracking-[-0.015em] ${TONE_CLS[tone]}`}>{value}</div>
    </div>
  )
}
